import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';
import { StepHeaderComponent, StepStateViewModel } from '../step-header/step-header.component';
import { StepFooterComponent } from '../step-footer/step-footer.component';
import { RemovableFileViewModel } from '@shared/models/removable-file.view-model';
import { NewFileViewModel } from '@shared/models/new-file.view-model';

@Component({
    selector: 'app-file-step',
    templateUrl: './file-step.component.html',
    styleUrls: ['./file-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [StepHeaderComponent, StepFooterComponent]
})
export class FileStepComponent {
    readonly title = input.required<string>();
    readonly description = input.required<string>();
    readonly state = input.required<StepStateViewModel>();
    readonly existingFiles = input.required<RemovableFileViewModel[]>();
    readonly newFiles = input.required<NewFileViewModel[]>();
    readonly editable = input.required<boolean>();
    readonly nextEnabled = input.required<boolean>();
    readonly fileTypeWhiteList = input.required<string>();

    readonly previousClicked = output<void>();
    readonly saveClicked = output<void>();
    readonly toggleRemoveExistingFile = output<RemovableFileViewModel>();
    readonly removeNewFile = output<NewFileViewModel>();
    readonly addNewFiles = output<Event>();
    readonly downloadFile = output<{ file: RemovableFileViewModel; lineNo: number }>();

    readonly fileInput = viewChild<ElementRef>('fileInput');

    previous(): void {
        this.previousClicked.emit();
    }

    save(): void {
        this.saveClicked.emit();
    }

    onDownloadFile(file: RemovableFileViewModel): void {
        this.downloadFile.emit({ file, lineNo: file.lineNo });
    }

    onToggleRemoveExistingFile(file: RemovableFileViewModel): void {
        this.toggleRemoveExistingFile.emit(file);
    }

    onRemoveNewFile(file: NewFileViewModel): void {
        this.removeNewFile.emit(file);
    }

    onAddNewFiles(event: Event): void {
        this.addNewFiles.emit(event);
        const fileInputEl = this.fileInput();
        if (fileInputEl) {
            fileInputEl.nativeElement.value = '';
        }
    }

    triggerFileInput(): void {
        const fileInputEl = this.fileInput();
        if (fileInputEl) {
            fileInputEl.nativeElement.click();
        }
    }
}
